import { yoyoHttp } from '../../services/http.service';
import { ACTIONS, MUTATIONS, HISTORY_PREFIX, CORE_PREFIX } from '../constants';
import { setHours, setMinutes, setSeconds, format } from 'date-fns';
import { faObjectUngroup } from '@fortawesome/free-solid-svg-icons';
import { AxiosResponse } from 'axios';
import { app } from '../../main';

function formatDateTime(date, second, minute, hour) {
    return setHours(setMinutes(setSeconds(date, second), minute), hour);
}

const actions = {
    
    async [ACTIONS.HISTORY.CHANGE_SHIPMENTS_ACCOUNT](ctx, request){
        const r = await yoyoHttp.post('/api/History/ChangeShipmentAccountAsync',request)
    },
    
    
    async [ACTIONS.HISTORY.INITIALIZE_HISTORY](ctx) {
        await ctx.dispatch(CORE_PREFIX + ACTIONS.CORE.INITIALIZE_SYSTEM, null, { root: true });


        await ctx.dispatch(ACTIONS.HISTORY.FETCH_SHIPMENT_DIRECTION);
        await ctx.dispatch(ACTIONS.HISTORY.FETCH_SEARCH_OPTIONS);
        await ctx.dispatch(ACTIONS.HISTORY.FETCH_DELIVERY_STATUSES);
        await ctx.dispatch(ACTIONS.HISTORY.FETCH_TRANSPORT_COMPANIES);

        let isCustomer = ctx.rootGetters[CORE_PREFIX + 'isCustomer'];

        //If customer - fetch based on companyId
        if (isCustomer) {
            await ctx.dispatch(
                ACTIONS.HISTORY.FETCH_COMPANY_ACCOUNTS,
                ctx.rootState.core.userData.companyId
            );

            await ctx.dispatch(
                ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_COMPANYID,
                ctx.rootState.core.userData.companyId
            );
        }

        //If admin - fetch everything
        else {
            await ctx.dispatch(ACTIONS.HISTORY.FETCH_ALL_COMPANY_ACCOUNTS);
            await ctx.dispatch(ACTIONS.HISTORY.FETCH_SALES_PRODUCTS);
        }
    },

    async [ACTIONS.HISTORY.FETCH_DOCUMENT_PACK](ctx, filter){
        filter.fromDate = formatDateTime(filter.fromDate, 0, 0, 0);
        filter.toDate = formatDateTime(filter.toDate, 59, 59, 23);
        
        const request = {
            date: filter.toDate,
            branchId: filter.branchId,
            forcePrint: filter.forcePrint
        }

        const r = await yoyoHttp
            .post('/api/History/GetDocumentPack', request, app.$t('errors.NoShipmentsFound'));

        if (r.status.toString().startsWith('2')) {
            ctx.commit(MUTATIONS.HISTORY.SET_SHIPMENTS, r.data.historyShipments);

            if (r.data.documentPackUrl)
                window.open(r.data.documentPackUrl, '_blank');
        }
    },

    async [ACTIONS.HISTORY.FETCH_HISTORY_SHIPMENTS](ctx, filter) {
        filter.fromDate = formatDateTime(filter.fromDate, 0, 0, 0);
        filter.toDate = formatDateTime(filter.toDate, 59, 59, 23);

        const r = await yoyoHttp
            .post('/api/History/FilterHistoryShipments', filter, app.$t('errors.NoShipmentsFound'));

        if (r.status.toString().startsWith('2')) {
            ctx.commit(MUTATIONS.HISTORY.SET_SHIPMENTS, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_HISTORY_SHIPMENT_INFO](ctx, shipmentId) {
        let response = await yoyoHttp.get('/api/Shipment/HistoryShipmentInfo/' + shipmentId, null);
        return response.data;
    },

    async [ACTIONS.HISTORY.RESTORE_SHIPMENTS](ctx, payload) {
        ctx.commit(MUTATIONS.HISTORY.RESTORE_SHIPMENTS, payload.ids);

        var request = payload.ids.map((id) => ({ id: id, bookInsurance: payload.bookInsurance }));
        const r = await yoyoHttp.delete('api/Shipment/RestoreShipments', { data: request });
    },

    async [ACTIONS.HISTORY.UPDATE_SENDER_RECEIVER_REFERENCE](ctx, shipment) {
        const request = {
            SendersReference: shipment.sendersReference,
            ReceiversReference: shipment.receiversReference
        };

        const r = await yoyoHttp.post(
            'api/History/SetSenderReceiverReference/' + shipment.id,
            request
        );
    },
    async [ACTIONS.HISTORY.FETCH_INVOICE](ctx, payload) {
        let r: AxiosResponse<any>;
        if (payload) {
            r = await yoyoHttp.get('/api/History/GetInvoice/', { params: payload });
        } else {
            r = await yoyoHttp.get('/api/History/GetInvoice/', null);
        }
        return r.data;
    },
    async [ACTIONS.HISTORY.CREATE_INVOICE](ctx, {invoice}) {
        const r = await yoyoHttp.post(`/api/Print/CreateInvoice`, invoice);

        if (r.status.toString().startsWith('2')) {
            return r.headers.location;
        }
    },
    [ACTIONS.HISTORY.SET_SELECTED_ROWS](ctx, rows) {
        ctx.commit(MUTATIONS.HISTORY.SET_SELECTED_ROWS, rows);
    },
    async [ACTIONS.HISTORY.UPDATE_TRANSIT_STATUS](ctx, shipmentUpdateRequest) {
        if (shipmentUpdateRequest.shipmentIds.length === 0) {
            return;
        }
        const shipmentsCopy = [...ctx.state.shipments];
        shipmentUpdateRequest.shipmentIds.forEach((element) => {
            const found = shipmentsCopy.find((x) => x.id === element);
            found.deliveryStatus = shipmentUpdateRequest.deliveryStatus;
        });
        ctx.commit(MUTATIONS.HISTORY.SET_SHIPMENTS, shipmentsCopy);
        const r = await yoyoHttp
            .post('api/History/SetTransitStatus/', shipmentUpdateRequest, app.$t('errors.Unauthorized'));
    },

    async [ACTIONS.HISTORY.UPDATE_TRACKING_LINK](ctx, shipment) {
        const request = {
            TrackingLink: shipment.trackingLink
        };

        const r = await yoyoHttp
            .post('api/History/SetTrackingLink/' + shipment.id, request, app.$t('errors.Unauthorized'));
    },

    async [ACTIONS.HISTORY.FETCH_INTERNAL_MESSAGES](ctx, shipmentId) {
        return await yoyoHttp.get('api/History/GetInternalMessages', {
            params: {
                id: shipmentId
            }
        });
    },

    async [ACTIONS.HISTORY.DELETE_SHIPMENTS](ctx, ids) {
        ctx.commit(MUTATIONS.HISTORY.DELETE_SHIPMENTS, ids);
        const r = await yoyoHttp.delete('api/Shipment/DeleteShipments', {
            params: {
                shipmentIds: ids
            }
        });
    },
    async [ACTIONS.HISTORY.TRANSFER_SHIPMENT](ctx, id) {
        //ctx.commit(MUTATIONS.HISTORY.TRANSFER_SHIPMENTS, id); //HEO this does not alter state
        const r = await yoyoHttp.post('api/Shipment/TransferShipmentToCargoWise?shipmentId=' + id, {
            params: {}
        });
    },

    async [ACTIONS.HISTORY.TRANSFER_SHIPMENTS](ctx, ids) {
        //ctx.commit(MUTATIONS.HISTORY.TRANSFER_SHIPMENTS, id); //HEO this does not alter state
        // debugger;
        const r = await yoyoHttp.post('api/Shipment/TransferShipmentsToCargoWise', ids);
    },

    async [ACTIONS.HISTORY.TRANSFER_SHIPMENT_INVOICING](ctx, ids) {
        //ctx.commit(MUTATIONS.HISTORY.TRANSFER_SHIPMENTS, id); //HEO this does not alter state
        // debugger;
        const r = await yoyoHttp.post('api/Shipment/TransferShipmentsToInvoicing', ids);
    },

    async [ACTIONS.HISTORY.DELETE_DOCUMENTS](ctx, request) {
        const r = await yoyoHttp.post('api/History/DeleteDocuments', request);
    },

    async [ACTIONS.HISTORY.ADD_PRICE_LINES](ctx, request) {
        const r = await yoyoHttp
            .post('api/History/AddPriceLines', request, app.$t('errors.Unauthorized'));
    },

    async [ACTIONS.HISTORY.FETCH_EMAIL_TEMPLATES](ctx, shipmentId) {
        return await yoyoHttp.get('api/History/GetEmailTemplates/' + shipmentId, null);
    },

    async [ACTIONS.HISTORY.FETCH_PRICE_LINE_TYPES](ctx) {
        return await yoyoHttp.get('api/History/GetPriceLineTypes', null);
    },

    async [ACTIONS.HISTORY.FETCH_COMPANY_ACCOUNTS](ctx, companyId) {
        const r = await yoyoHttp
            .get('/api/User/GetCompanyAccounts', {
                params: {
                    userId: ctx.rootState.core.userData.id,
                    companyId: companyId
                }
            }, app.$t('errors.noCompanyAccounts'));

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_COMPANY_ACCOUNTS, r.data);

            return r;
        }
    },

    async [ACTIONS.HISTORY.FETCH_ALL_COMPANY_ACCOUNTS](ctx) {
        const r = await yoyoHttp.get('api/user/GetAllCompanyAccounts', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_COMPANY_ACCOUNTS, r.data);
        }
    },

    async [ACTIONS.HISTORY.SEND_EMAIL_TEMPLATE](ctx, payload) {
        const request = payload.template;

        yoyoHttp
            .post('api/History/SendEmailTemplate?shipmentId=' + payload.shipmentId, request, app.$t('errors.Unauthorized'));
    },

    async [ACTIONS.HISTORY.SET_INTERNAL_MESSAGE](ctx, obj) {
        const request = {
            CreatedBy: ctx.rootState.core.userData.id,
            Message: obj.message,
            ShipmentId: obj.shipment.id
        };

        const r = await yoyoHttp
            .post('api/History/SetInternalMessage', request, app.$t('errors.Unauthorized'));
    },
    async [ACTIONS.HISTORY.FETCH_LABELS](ctx) {
        if (ctx.state.selectedRows.length === 0) {
            return;
        }
        const ids = ctx.state.selectedRows.map((x) => x.id);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp.post('/api/Print/CreateLabels', ids);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        return r.headers.location;
    },
    async [ACTIONS.HISTORY.FETCH_LABEL](ctx, id) {
        if (id === null || isNaN(id)) {
            return;
        }

        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp
            .get('/api/Print/CreateLabel/' + id, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf'
                }
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Air way bill.pdf');
                document.body.appendChild(link);
                link.click();
            });
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
    },
    async [ACTIONS.HISTORY.FETCH_MANIFEST](ctx) {
        if (ctx.state.selectedRows.length === 0) {
            return;
        }
        const ids = ctx.state.selectedRows.map((x) => x.id);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp.post('/api/Print/CreateManifest', ids);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        return r.headers.location;
    },
    async [ACTIONS.HISTORY.FETCH_CSV](ctx) {
        if (ctx.state.selectedRows.length === 0) {
            return;
        }
        const ids = ctx.state.selectedRows.map((x) => x.id);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp.post('/api/History/CreateExcel', ids);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        return r.headers.location;
    },
    async [ACTIONS.HISTORY.FETCH_LABEL_AND_DOCUMENTS_WITHOUT_CONNOTE](ctx) {
        if (ctx.state.selectedRows.length === 0) {
            return;
        }
        const ids = ctx.state.selectedRows.map((x) => x.id);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp.post('/api/Print/CreateLabelAndDocumentsWithoutConnote', ids);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        return r.headers.location;
    },
    async [ACTIONS.HISTORY.FETCH_LABEL_AND_DOCUMENTS](ctx) {
        if (ctx.state.selectedRows.length === 0) {
            return;
        }
        const ids = ctx.state.selectedRows.map((x) => x.id);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        const r = await yoyoHttp.post('/api/Print/CreateLabelAndDocuments', ids);
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        return r.headers.location;
    },

    async [ACTIONS.HISTORY.UPDATE_SHIP_DATE](ctx, obj) {
        const request = {
            ShipDate: obj.shipDate
        };

        const r = await yoyoHttp
            .post('api/History/SetShipDate/' + obj.shipment.id, request, app.$t('errors.Unauthorized'));
    },
    
    async [ACTIONS.HISTORY.UPDATE_EXPECTED_DELIVERY_DATE](ctx, obj) {
        const request = {
            ExpectedDeliveryDate: obj.expectedDeliveryDate
        };

        const r = await yoyoHttp
            .post('api/History/SetExpectedDeliveryDate/' + obj.shipment.id, request, app.$t('errors.Unauthorized'));
    },

    async [ACTIONS.HISTORY.UPDATE_SHIP_AWB](ctx, obj) {
        const request = {
            ShipAWB: obj.awb
        };

        return await yoyoHttp
            .post('api/History/SetShipAWB/' + obj.shipment.id, request, app.$t('errors.Unauthorized'));
    },
    
    async [ACTIONS.HISTORY.FETCH_PRICE_LINES](ctx, payload){
          const r = await yoyoHttp
              .get('api/History/GetPriceLines?shipmentId='+ payload.shipmentId + "&linkId=" + payload.linkId, null)
        
          if(r.status === 200){
              return r.data
          }
    },

    async [ACTIONS.HISTORY.FETCH_SHIPMENT_DIRECTION](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetShipmentTypes', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_SHIPMENT_DIRECTION, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_SALES_PRODUCTS](ctx) {
        const r = await yoyoHttp.cachedGet('api/User/GetSalesProducts', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_SALES_PRODUCTS, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_COMPANYID](ctx, companyId) {
        const r = await yoyoHttp.get('api/User/GetSalesProductsByCompanyId/' + companyId, null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_SALES_PRODUCTS, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_SALES_PRODUCTS_BY_ACCOUNTID](ctx, accountId) {
        const r = await yoyoHttp.get('api/User/GetSalesProductsByAccountId/' + accountId, null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_SALES_PRODUCTS, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_SEARCH_OPTIONS](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetSearchOptions', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_SEARCH_OPTIONS, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_DELIVERY_STATUSES](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetDeliveryStatuses', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_DELIVERY_STATUSES, r.data);
        }
    },

    async [ACTIONS.HISTORY.FETCH_TRANSPORT_COMPANIES](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetTransportCompanies', null);
        
        var data = r.data;
        
        var array: Array<Carrier> = [];
        
        data.forEach(el => {
            var obj = {label: el.replace("YOYO",'Link'), value: el} as Carrier
            array.push(obj)
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.HISTORY.SET_TRANSPORT_COMPANIES, array);
        }
    },


    [ACTIONS.HISTORY.SET_FILTER](ctx, filter) {
        ctx.commit(MUTATIONS.HISTORY.SET_FILTER, filter);
    }
};

interface Carrier {
    label: string;
    value: string;
}

export default actions;
